class CountryDrawerTrigger extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this.#open);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.#open);
  }

  #open = () => {
    const targetId = this.getAttribute("target");
    const drawer = document.getElementById(targetId);
    if (drawer && typeof drawer.showDialog === "function") {
      drawer.showDialog();
    }
  };
}

if (!customElements.get("country-drawer-trigger")) {
  customElements.define("country-drawer-trigger", CountryDrawerTrigger);
}
